'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = initAccordions;

require('jquery');

/**
 * An accordion expands a section when you click on it. If you click on an
 * element while another is already opened, the already opened ones will close.
 */

/**
 * Inits accordions by binding a click event on their toggle.
 */
function initAccordions() {

    $('.accordion__item-toggle').click(function (e) {

        e.preventDefault();

        var $this = $(this),
            $accordionItems = $this.parent().parent().find('.accordion__item'),
            $currentAccordionItem = $this.parent(),
            $currentAccordionItemInner = $currentAccordionItem.find('.accordion__item-inner'),
            $currentAccordionItemIcon = $currentAccordionItem.find('.accordion__item-toggle__icon');

        if ($currentAccordionItemInner.hasClass('show')) {

            $this.removeClass('accordion__item-toggle--selected');
            $currentAccordionItemIcon.removeClass('accordion__item-toggle__icon--selected');
            $currentAccordionItemInner.removeClass('show');
            $currentAccordionItemInner.slideUp(350);
        } else {

            $accordionItems.find('.accordion__item-inner').removeClass('show');
            $accordionItems.find('.accordion__item-toggle').removeClass('accordion__item-toggle--selected');
            $accordionItems.find('.accordion__item-toggle__icon').removeClass('accordion__item-toggle__icon--selected');
            $accordionItems.find('.accordion__item-inner').slideUp(350);
            $currentAccordionItemInner.toggleClass('show');
            $currentAccordionItemInner.slideToggle(350);
            $this.toggleClass('accordion__item-toggle--selected');
            $currentAccordionItemIcon.toggleClass('accordion__item-toggle__icon--selected');
        }
    });
}